<template>
<!-- v-if="false" quick way to block comment -->
<section class="kc-elm kc-css-562143 kc_row" v-if="false">
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="befbgr5" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="befbgr6" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="aftbgr7" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="aftbgr8" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="kc-row-container  kc-container">
      <div class="kc-wrap-columns">
         <div class="kc-elm kc-css-950971 kc_col-sm-6 kc_column kc_col-sm-6">
            <div class="kc-col-container">
               <div class="ssc_mltttl  kc-elm kc-css-778022 ">
                  <div class="wr deb derb dea dera none nonea">
                     <h2 class="t1">Be </h2>
                     <h2 class="t2">In Touch</h2>
                     <p class="t3">Send your requirements for a website, we will research your specification and competitors, create a prototype of the website for free and sed a result to you! It will be something amazing!</p>
                  </div>
               </div>
               <div class="kc-elm kc-css-780843 kc_row kc_row_inner sst-flex-row-inner">
                  <div class="kc-elm kc-css-175726 kc_col-sm-6 kc_column_inner kc_col-sm-6">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class="ssc_icon_box kc-elm kc-css-520788 template3 ">
                           <div class="icon_box">
                              <div class="bgr_icon"><i class="nat-cirleborder" style="font-size:70px; width:70px; height:70px"></i></div>
                              <div class="c_svg" style="margin-top: -70px;">
                                 <div>
                                    <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
                                       <g clip-path="url(#clip0)">
                                          <path d="M18.5156 15.2344C18.1922 15.2344 17.9297 15.4969 17.9297 15.8203C17.9297 16.1437 18.1922 16.4062 18.5156 16.4062C18.839 16.4062 19.1016 16.1437 19.1016 15.8203C19.1016 15.4969 18.839 15.2344 18.5156 15.2344Z"></path>
                                          <path d="M5.98734 21.6671L0.127968 29.0499C-0.0118793 29.2259 -0.0384295 29.4665 0.059303 29.6688C0.157036 29.8714 0.362114 30 0.586876 30H29.415C29.6398 30 29.8448 29.8714 29.9426 29.6688C30.0405 29.4665 30.0138 29.2259 29.8739 29.0499L24.0145 21.6671C23.9035 21.527 23.7344 21.4453 23.5556 21.4453H18.423L22.8049 14.5724C23.8328 13.0314 24.3759 11.2342 24.3759 9.375C24.3759 4.2057 20.1705 0 15.0009 0C9.83141 0 5.62594 4.2057 5.62594 9.375C5.62594 11.2342 6.16907 13.0312 7.19698 14.5724L11.5789 21.4453H6.44625C6.26749 21.4453 6.09858 21.527 5.98734 21.6671ZM3.79969 26.3086H7.34255L5.34304 28.8281H1.79995L3.79969 26.3086ZM12.3262 22.6172L13.9325 25.1367H9.7687L11.7684 22.6172H12.3262ZM17.6759 22.6172H18.2337L20.2332 25.1367H16.0696L17.6759 22.6172ZM21.1634 26.3086L23.1629 28.8281H6.83901L8.83875 26.3086H21.1634ZM24.6591 28.8281L22.6593 26.3086H26.2024L28.2019 28.8281H24.6591ZM25.2722 25.1367H21.7294L19.7296 22.6172H23.2727L25.2722 25.1367ZM8.17522 13.927C7.27412 12.578 6.79781 11.004 6.79781 9.375C6.79781 4.85184 10.4778 1.17188 15.0009 1.17188C19.5241 1.17188 23.2041 4.85184 23.2041 9.375C23.2041 11.004 22.7278 12.578 21.8269 13.927C21.8244 13.9304 21.8223 13.9339 21.82 13.9373C21.4353 14.5409 15.2973 24.1681 15.0009 24.6327C14.2555 23.4634 8.94106 15.1279 8.18186 13.9373C8.1798 13.9339 8.17751 13.9304 8.17522 13.927ZM10.2722 22.6172L8.27273 25.1367H4.72964L6.72938 22.6172H10.2722Z"></path>
                                          <path d="M15 15.2344C18.2167 15.2344 20.8594 12.6295 20.8594 9.375C20.8594 6.1441 18.2309 3.51562 15 3.51562C11.7691 3.51562 9.14062 6.1441 9.14062 9.375C9.14062 12.6304 11.7842 15.2344 15 15.2344ZM15 4.6875C17.5848 4.6875 19.6875 6.79024 19.6875 9.375C19.6875 11.9838 17.5678 14.0625 15 14.0625C12.4315 14.0625 10.3125 11.9838 10.3125 9.375C10.3125 6.79024 12.4152 4.6875 15 4.6875Z"></path>
                                          <path d="M17.4683 17.2339C17.1913 17.0668 16.831 17.1561 16.664 17.4332L14.4983 21.0262C14.3312 21.3034 14.4205 21.6634 14.6976 21.8305C14.976 21.9983 15.3355 21.9072 15.5019 21.6311L17.6676 18.0382C17.8347 17.761 17.7454 17.401 17.4683 17.2339Z"></path>
                                       </g>
                                       <defs>
                                          <clipPath>
                                             <rect width="30" height="30" fill="white"></rect>
                                          </clipPath>
                                       </defs>
                                    </svg>
                                 </div>
                              </div>
                           </div>
                           <div class="cont_box">
                              <div class="title">Address</div>
                              <div class="description lines0">
                                 <p>77 Geary St 5th floor, San Francisco<br/>CA 94018, United States</p>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-942704 kc_col-sm-6 kc_column_inner kc_col-sm-6">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class="ssc_icon_box kc-elm kc-css-734883 template3 ">
                           <div class="icon_box">
                              <div class="bgr_icon"><i class="nat-cirleborder" style="font-size:70px; width:70px; height:70px"></i></div>
                              <div class="c_svg" style="margin-top: -70px;">
                                 <div>
                                    <svg width="30" height="23" viewBox="0 0 30 23" xmlns="http://www.w3.org/2000/svg">
                                       <path d="M29.4023 0H0.597597C0.267597 0 0 0.310291 0 0.693093V18.955C0 20.9097 1.37109 22.5 3.05654 22.5H26.9435C28.6289 22.5 30 20.9097 30 18.955V0.693093C29.9999 0.310291 29.7323 0 29.4023 0ZM28.8047 18.955C28.8047 20.1453 27.9698 21.1137 26.9435 21.1137H3.05654C2.03021 21.1137 1.19525 20.1452 1.19525 18.955V2.20527L14.6214 14.9529C14.7316 15.0574 14.8657 15.1097 15 15.1097C15.134 15.1097 15.268 15.0576 15.378 14.9534L25.767 5.11125C26.0226 4.86905 26.0606 4.43249 25.8518 4.136C25.6429 3.8395 25.2666 3.79546 25.0109 4.03773L15.0004 13.5213L2.21947 1.38619H28.8047V18.955Z"></path>
                                    </svg>
                                 </div>
                              </div>
                           </div>
                           <div class="cont_box">
                              <div class="title">Email</div>
                              <div class="description lines0">
                                 <p>sales@globaldev.io<br>marketing@globaldev.io</p>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="kc-elm kc-css-187788 kc_row kc_row_inner sst-flex-row-inner">
                  <div class="kc-elm kc-css-309455 kc_col-sm-6 kc_column_inner kc_col-sm-6">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class="ssc_icon_box kc-elm kc-css-998378 template3 ">
                           <div class="icon_box">
                              <div class="bgr_icon"><i class="nat-cirleborder" style="font-size:70px; width:70px; height:70px"></i></div>
                              <div class="c_svg" style="margin-top: -70px;">
                                 <div>
                                    <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
                                       <g clip-path="url(#clip0)">
                                          <path d="M29.9804 24.6914C29.885 23.9705 29.4688 23.3489 28.8387 22.9862L21.4376 18.7249C20.5312 18.203 19.3812 18.3549 18.6413 19.0947L17.1835 20.5525C16.7956 20.9405 16.1819 20.9748 15.7563 20.6323C14.607 19.7075 13.4755 18.6898 12.3931 17.6074C11.3107 16.525 10.293 15.3935 9.3682 14.2442C9.02563 13.8185 9.05991 13.2049 9.44796 12.8169L10.9057 11.3591C11.6455 10.6193 11.7976 9.46951 11.2756 8.56285L7.01431 1.16174C6.65147 0.531561 6.02997 0.115457 5.30907 0.020081C4.58812 -0.0754895 3.87973 0.164959 3.36553 0.679161L1.16896 2.87579C-0.36412 4.40894 -0.388742 7.21333 1.09963 10.7725C2.53079 14.1948 5.20158 17.9621 8.61989 21.3806C12.0383 24.799 15.8057 27.4697 19.228 28.9009C20.98 29.6335 22.5489 29.9996 23.8735 29.9995C25.2399 29.9995 26.3462 29.6099 27.1247 28.8315L29.3213 26.6349C29.8354 26.1207 30.0757 25.4123 29.9804 24.6914V24.6914ZM20.9527 19.5671L28.3538 23.8284C28.7198 24.0391 28.9615 24.4001 29.0168 24.8188C29.0634 25.1702 28.9721 25.5162 28.7651 25.795L18.9291 20.1814L19.3286 19.782C19.7582 19.3523 20.4263 19.264 20.9527 19.5671V19.5671ZM5.18156 0.983626C5.60032 1.03902 5.96129 1.2807 6.17199 1.64672L10.4333 9.04783C10.7365 9.57441 10.6481 10.2423 10.2185 10.6719L9.85156 11.0388L4.20713 1.23535C4.43786 1.06449 4.71382 0.971704 5.0015 0.971704C5.06117 0.971704 5.12137 0.975656 5.18156 0.983626V0.983626ZM26.4374 28.1442C25.2194 29.3622 22.7284 29.3112 19.603 28.0042C16.2946 26.6207 12.6383 24.0243 9.30723 20.6933C5.97619 17.3623 3.37978 13.7058 1.99631 10.3975C0.689228 7.2721 0.638236 4.78105 1.85623 3.56299L3.48688 1.93227L9.1398 11.7506L8.76069 12.1297C8.02107 12.8694 7.95667 14.0403 8.61095 14.8536C9.55752 16.03 10.5988 17.1877 11.7058 18.2946C12.8128 19.4016 13.9705 20.4429 15.1469 21.3895C15.96 22.0438 17.131 21.9795 17.8708 21.2397L18.2167 20.8938L28.0663 26.5153L26.4374 28.1442V28.1442Z"></path>
                                       </g>
                                       <defs>
                                          <clipPath>
                                             <rect width="30" height="30" fill="white"></rect>
                                          </clipPath>
                                       </defs>
                                    </svg>
                                 </div>
                              </div>
                           </div>
                           <div class="cont_box">
                              <div class="title">Phone number</div>
                              <div class="description lines0">
                                 <p>+9 888 99 99 888<br>+9 777 55 55 444</p>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-13313 kc_col-sm-6 kc_column_inner kc_col-sm-6">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class="ssc_icon_box kc-elm kc-css-31761 template3 ">
                           <div class="icon_box">
                              <div class="bgr_icon"><i class="nat-cirleborder" style="font-size:70px; width:70px; height:70px"></i></div>
                              <div class="c_svg" style="margin-top: -70px;">
                                 <div>
                                    <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
                                       <path d="M26.3134 0H3.68669C1.65383 0 0 1.65383 0 3.68658V26.3134C0 28.3463 1.65383 30 3.68658 30C4.02368 30 4.29708 29.7266 4.29708 29.3895C4.29708 29.0524 4.02368 28.779 3.68658 28.779C2.32711 28.7791 1.22099 27.673 1.22099 26.3134V3.68658C1.22099 2.32711 2.32711 1.22099 3.68669 1.22099H26.3134C27.673 1.22099 28.779 2.32711 28.779 3.68658V26.3134C28.779 27.673 27.673 28.779 26.3134 28.779H10.2179C9.88078 28.779 9.60738 29.0524 9.60738 29.3895C9.60738 29.7266 9.88078 30 10.2179 30H26.3134C28.3463 30 30 28.3462 30 26.3134V3.68658C30.0001 1.65383 28.3463 0 26.3134 0Z"></path>
                                       <path d="M15.0001 5.29016C14.663 5.29016 14.3896 5.56356 14.3896 5.90066V15.0001C14.3896 15.162 14.454 15.3173 14.5684 15.4318L24.7434 25.6068C24.8625 25.7259 25.0188 25.7855 25.175 25.7855C25.3312 25.7855 25.4875 25.7259 25.6066 25.6068C25.8451 25.3684 25.8451 24.9818 25.6066 24.7434L15.6105 14.7473V5.90066C15.6106 5.56346 15.3372 5.29016 15.0001 5.29016Z"></path>
                                    </svg>
                                 </div>
                              </div>
                           </div>
                           <div class="cont_box">
                              <div class="title">Working hours</div>
                              <div class="description lines0">
                                 <p>Mon - Fri: 10:00 - 19:00<br>Sat - Sun: day off</p>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="kc-elm kc-css-296257 kc_col-sm-6 kc_column kc_col-sm-6 ssc-full-col ssc-col-right">
            <div class="kc-col-container"></div>
         </div>
      </div>
   </div>
</section>


</template>

<script>
import Article from "@/components/layout/Article";

export default {
  name: "Contact",
  components: {
    Article
  },
  data() {
    return {
      subtitle: "GDPR"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*! CSS Used from: https://demo26.atiframe.com/wp-content/cache/min/1/57bcd27410ed02718466378646e07220.css ; media=all */
@media all{
*,.kc-col-container,.kc-container,.kc-elm{box-sizing:border-box;}
div{display:block;}
.kc-elm{float:left;width:100%;}
.kc_col-sm-6{width:50%;}
.kc-container{width:100%;max-width:1170px;margin:0 auto;padding-left:15px;padding-right:15px;}
.kc_row:not(.kc_row_inner){clear:both;float:left;width:100%;}
.kc-row-container.kc-container .kc-wrap-columns,.kc_row_inner{margin-left:-15px;margin-right:-15px;clear:both;}
.kc_row.kc_row_inner{width:calc(100% + 30px);}
.kc_column,.kc_column_inner{min-height:1px;position:relative;padding-right:15px;padding-left:15px;float:left;}
.kc_column>.kc-col-container,.kc_column_inner>.kc-col-inner-container{height:100%;}
.kingcomposer div.kc_column,.kingcomposer div.kc_column_inner{clear:none;}
.kc-col-container{clear:both;display:block;width:100%;}
@media screen and (min-width:999px){
.kc-row-container .kc-wrap-columns,.kc_row_inner{display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;flex-wrap:wrap;}
.kc-row-container.kc-container .kc-wrap-columns,.kc_row_inner{width:calc(100% + 30px);}
}
@media screen and (max-width:767px){
body.kc-css-system .kc_column,body.kc-css-system .kc_column_inner{width:100%;}
div.kc_row{display:block;}
}
[class^="nat-"]{font-family:'native'!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}
.nat-cirleborder:before{content:"\ebd0";}
*{box-sizing:border-box;}
*:before,*:after{box-sizing:border-box;}
div:focus,i:focus{outline:none;}
section{display:block;}
svg:not(:root){overflow:hidden;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:40px;line-height:52px;text-transform:capitalize;text-align:left;margin:20px 0 15px 0;}
p{margin:10px 0 25px 0;}
.page p{line-height:29px;}
i{font-style:italic;}
*,*:before,*:after{box-sizing:inherit;}
.kc_row.kc_row_inner:focus{outline:none;}
.kc-row-container:after{content:"";display:block;clear:both;}
.kc-col-container>div{position:relative;}
@media screen and (max-width:601px){
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;}
p{margin:10px 0 25px 0;line-height:26px;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;margin:20px 0;}
}
section{position:relative;}
.befbgr,.befbgr5,.befbgr6{position:absolute;top:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.aftbgr,.aftbgr7,.aftbgr8{position:absolute;bottom:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.c_svg{display:table;z-index:2;position:relative;}
.c_svg div{display:table-cell;width:100%;vertical-align:middle;}
.c_svg svg{max-width:100%;max-height:100%;}
.ssc_icon_box.kc-elm{margin-bottom:10px;width:auto;}
.ssc_icon_box:after{content:"";display:block;clear:both;}
.ssc_icon_box i{transition:all 300ms ease-in;}
.ssc_icon_box,.ssc_icon_box .bgr_icon,.ssc_icon_box .bgr_icon i,.ssc_icon_box .icon_box,.ssc_icon_box .cont_box,.ssc_icon_box .title,.ssc_icon_box .cont_box .description,.ssc_icon_box .c_svg{transition:all 350ms ease-in;}
.ssc_icon_box.template3{text-align:center;}
.ssc_icon_box.template3 .title{margin-top:20px;}
.ssc_icon_box.template3 .bgr_icon i{margin:0 auto;}
.ssc_icon_box.template3 .c_svg{margin-left:auto;margin-right:auto;}
.ssc_icon_box.template3 .icon_box{width:100%;}
.ssc_icon_box .bgr_icon{position:relative;z-index:1;}
.ssc_icon_box .bgr_icon i{display:block;}
.ssc_icon_box .icon_box{width:10px;}
.ssc_icon_box .cont_box{vertical-align:top;}
.ssc_icon_box .title{margin-bottom:2px;font-size:20px;font-weight:700;}
.ssc_icon_box .cont_box .description{line-height:1.4em;}
.ssc_icon_box .cont_box .description p:first-child{margin-top:0;}
.ssc_icon_box .cont_box .description p:last-child{margin-bottom:0;}
.main [class*="lines"]{display:-webkit-box!important;-webkit-box-orient:vertical;overflow:hidden;}
@media screen and (max-width:1024px){
.befbgr,.befbgr5,.befbgr6,.aftbgr,.aftbgr7,.aftbgr8{overflow:hidden;}
}
@media screen and (max-width:480px){
.ssc_icon_box .bgr_icon i{margin-left:auto;margin-right:auto;}
.ssc_icon_box .icon_box{text-align:center;}
}
.ssc_mltttl .wr p{margin:0;}
.ssc_mltttl>div{display:block;width:auto;position:relative;}
.deb:before,.dea:after{position:absolute;content:'';display:block;top:0;transition:all 400ms;}
.deb.none:before,.dea.nonea:after{content:none;}
.derb:before,.dera:after{right:0;}
.kc-col-container:after{content:"";display:block;clear:both;}
.sst-flex-row-inner{position:relative;z-index:1;min-height:30px;}
@media (min-width:1025px){
.kc_column.ssc-full-col{position:absolute;top:0;bottom:0;height:auto;}
.ssc-full-col.ssc-col-right{right:0;}
}
}
/*! CSS Used from: Embedded */
@media (max-width: 479px){
h2{font-size:30px;line-height:34px!important;}
p.t3{font-size:20px;line-height:26px;padding-top:20px!important;}
}
/*! CSS Used from: Embedded */
.kc-container{max-width:1170px;}
/*! CSS Used from: Embedded */
@media only screen and (min-width:1000px) and (max-width:5000px){
body.kc-css-system .kc-css-950971{width:50%;}
body.kc-css-system .kc-css-175726{width:50%;}
body.kc-css-system .kc-css-942704{width:50%;}
body.kc-css-system .kc-css-309455{width:50%;}
body.kc-css-system .kc-css-13313{width:50%;}
body.kc-css-system .kc-css-296257{width:50%;}
}
body.kc-css-system .kc-css-950971{padding-top:120px;padding-bottom:90px;}
body.kc-css-system .kc-css-778022.ssc_mltttl .wr{text-align:left;}
body.kc-css-system .kc-css-778022{text-align:center;display:inline-block;}
body.kc-css-system .kc-css-778022 .deb:before{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-left:455px;}
body.kc-css-system .kc-css-778022 .deb:after{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-right:455px;}
body.kc-css-system .kc-css-778022 .t1{text-align:center;text-transform:capitalize;display:inline;}
body.kc-css-system .kc-css-778022 .t2{color:#ED7D31;display:inline;}
body.kc-css-system .kc-css-778022 .t3{padding-top:17px;padding-right:60px;}
body.kc-css-system .kc-css-780843{padding-top:60px;padding-bottom:60px;}
body.kc-css-system .kc-css-520788{text-align:left;width:100%;padding-bottom:13px;}
body.kc-css-system .kc-css-520788 .icon_box{height:70px;padding-bottom:0px;}
body.kc-css-system .kc-css-520788 .c_svg{padding-top:calc((70px - 30px)/2);max-height:30px;width:30px;margin-top:-70px;margin-left:20px;}
body.kc-css-system .kc-css-520788 .c_svg svg{fill:#222222;}
body.kc-css-system .kc-css-520788 .c_svg div{height:30px;}
body.kc-css-system .kc-css-520788 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-520788 .bgr_icon i{line-height:75px;margin-left:0px;}
body.kc-css-system .kc-css-520788 .bgr_icon i{text-align:left;}
body.kc-css-system .kc-css-520788 .title{color:#222222;font-size:20px;line-height:20px;font-weight:500;text-transform:none;}
body.kc-css-system .kc-css-520788 .cont_box .description{padding-top:10px;}
body.kc-css-system .kc-css-520788 .cont_box{padding-top:10px;}
body.kc-css-system .kc-css-520788:hover .c_svg svg{fill:#ED7D31;}
body.kc-css-system .kc-css-734883{text-align:left;width:100%;padding-bottom:13px;}
body.kc-css-system .kc-css-734883 .icon_box{height:70px;padding-bottom:0px;}
body.kc-css-system .kc-css-734883 .c_svg{padding-top:calc((70px - 30px)/2);max-height:30px;width:30px;margin-top:-70px;margin-left:20px;padding-top:26px;}
body.kc-css-system .kc-css-734883 .c_svg svg{fill:#222222;}
body.kc-css-system .kc-css-734883 .c_svg div{height:30px;}
body.kc-css-system .kc-css-734883 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-734883 .bgr_icon i{line-height:75px;margin-left:0px;}
body.kc-css-system .kc-css-734883 .bgr_icon i{text-align:left;}
body.kc-css-system .kc-css-734883 .title{color:#222222;font-size:20px;line-height:20px;font-weight:500;text-transform:none;}
body.kc-css-system .kc-css-734883 .cont_box .description{padding-top:10px;}
body.kc-css-system .kc-css-734883 .cont_box{padding-top:10px;}
body.kc-css-system .kc-css-734883:hover .c_svg svg{fill:#ED7D31;}
body.kc-css-system .kc-css-998378{text-align:left;width:100%;padding-bottom:13px;}
body.kc-css-system .kc-css-998378 .icon_box{height:70px;padding-bottom:0px;}
body.kc-css-system .kc-css-998378 .c_svg{padding-top:calc((70px - 30px)/2);max-height:30px;width:30px;margin-top:-70px;margin-left:20px;padding-top:24px;}
body.kc-css-system .kc-css-998378 .c_svg svg{fill:#222222;}
body.kc-css-system .kc-css-998378 .c_svg div{height:30px;}
body.kc-css-system .kc-css-998378 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-998378 .bgr_icon i{line-height:75px;margin-left:0px;}
body.kc-css-system .kc-css-998378 .bgr_icon i{text-align:left;}
body.kc-css-system .kc-css-998378 .title{color:#222222;font-size:20px;line-height:20px;font-weight:500;text-transform:none;}
body.kc-css-system .kc-css-998378 .cont_box .description{padding-top:10px;}
body.kc-css-system .kc-css-998378 .cont_box{padding-top:10px;}
body.kc-css-system .kc-css-998378:hover .c_svg svg{fill:#ED7D31;}
body.kc-css-system .kc-css-31761{text-align:left;width:100%;padding-bottom:13px;}
body.kc-css-system .kc-css-31761 .icon_box{height:70px;padding-bottom:0px;}
body.kc-css-system .kc-css-31761 .c_svg{padding-top:calc((70px - 30px)/2);max-height:30px;width:30px;margin-top:-70px;margin-left:20px;padding-top:23px;}
body.kc-css-system .kc-css-31761 .c_svg svg{fill:#222222;}
body.kc-css-system .kc-css-31761 .c_svg div{height:30px;}
body.kc-css-system .kc-css-31761 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-31761 .bgr_icon i{line-height:75px;margin-left:0px;}
body.kc-css-system .kc-css-31761 .bgr_icon i{text-align:left;}
body.kc-css-system .kc-css-31761 .title{color:#222222;font-size:20px;line-height:20px;font-weight:500;text-transform:none;}
body.kc-css-system .kc-css-31761 .cont_box .description{padding-top:10px;}
body.kc-css-system .kc-css-31761 .cont_box{padding-top:10px;}
body.kc-css-system .kc-css-31761:hover .c_svg svg{fill:#ED7D31;}
body.kc-css-system .kc-css-296257{background:transparent url(../../assets/images/Contacts-long-1.jpg) center center/cover no-repeat scroll;padding-right:0px;}
@media only screen and (max-width:768px){
body.kc-css-system .kc-css-778022 .deb:before{display:none;}
body.kc-css-system .kc-css-778022 .deb:after{display:none;}
body.kc-css-system .kc-css-778022 .t3{padding-right:0px;}
}
@media only screen and (max-width:667px){
body.kc-css-system .kc-css-778022 .t3{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-520788{display:flex;}
body.kc-css-system .kc-css-520788 .icon_box{width:20%;}
body.kc-css-system .kc-css-520788 .cont_box{margin-top:-30px;}
body.kc-css-system .kc-css-734883{display:flex;}
body.kc-css-system .kc-css-734883 .icon_box{width:20%;}
body.kc-css-system .kc-css-734883 .cont_box{margin-top:-30px;}
body.kc-css-system .kc-css-998378{display:flex;}
body.kc-css-system .kc-css-998378 .icon_box{width:20%;}
body.kc-css-system .kc-css-998378 .cont_box{margin-top:-30px;}
body.kc-css-system .kc-css-31761{display:flex;}
body.kc-css-system .kc-css-31761 .icon_box{width:20%;}
body.kc-css-system .kc-css-31761 .cont_box{margin-top:-30px;}
}
@media only screen and (max-width:1024px){
body.kc-css-system .kc-css-950971{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-296257{display:none;}
body.kc-css-system .kc-css-296257{margin-left:0%;width:100%;}
}
@media only screen and (max-width:999px){
body.kc-css-system .kc-css-950971{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-175726{margin-left:0%;width:50%;}
body.kc-css-system .kc-css-942704{margin-left:0%;width:50%;}
body.kc-css-system .kc-css-309455{margin-left:0%;width:50%;}
body.kc-css-system .kc-css-13313{margin-left:0%;width:50%;}
body.kc-css-system .kc-css-296257{margin-left:0%;width:100%;}
}
@media only screen and (max-width:479px){
body.kc-css-system .kc-css-562143{padding-bottom:80px;}
body.kc-css-system .kc-css-950971{padding-top:80px;padding-bottom:40px;}
body.kc-css-system .kc-css-778022.ssc_mltttl .wr{text-align:left;}
body.kc-css-system .kc-css-778022 .t2{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-778022 .t3{padding-left:0px;}
body.kc-css-system .kc-css-780843{padding-bottom:0px;}
body.kc-css-system .kc-css-175726{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-520788 .icon_box{width:40%;}
body.kc-css-system .kc-css-942704{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-734883 .icon_box{width:40%;}
body.kc-css-system .kc-css-309455{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-998378 .icon_box{width:40%;}
body.kc-css-system .kc-css-13313{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-31761 .icon_box{width:40%;}
}
/*! CSS Used fontfaces */
@font-face{font-display:swap;font-family:'native';src:url(../../assets/fonts/native.eot?3hn4ip);src:url('../../assets/fonts/native.eot?3hn4ip#iefix') format('embedded-opentype'),url(../../assets/fonts/native.ttf?3hn4ip) format('truetype'),url(../../assets/fonts/native.woff?3hn4ip) format('woff'),url('../../assets/fonts/native.svg?3hn4ip#native') format('svg');font-weight:400;font-style:normal;}

</style>



// WEBPACK FOOTER //
// src/components/Views/Contact.vue